import React from 'react';

const TermsOfService: React.FC = () => {
  return (
    <div className="terms-page">
      <h1>Terms of Service</h1>
      <p>
        Welcome to Lan4ai. By using our services at www.lan4ai.com, you agree to abide by these Terms of Service.
        Our platform provides AI-driven analytics designed to derive actionable insights and propel your organization into the future.
      </p>
      <h2>Acceptance of Terms</h2>
      <p>
        Your use of our services signifies your acceptance of our policies and procedures, including our Privacy Policy.
      </p>
      <h2>Service Description</h2>
      <p>
        Lan4ai leverages advanced AI and Retrieval Augmented Generation (RAG) technology to help you ask questions about your data and receive visualizations and recommendations.
      </p>
      <h2>User Responsibilities</h2>
      <p>
        Users must provide accurate information and comply with all applicable data protection regulations.
      </p>
      <h2>Modifications</h2>
      <p>
        We reserve the right to modify these Terms of Service at any time. Continued use of our platform constitutes acceptance of any changes.
      </p>
    </div>
  );
};

export default TermsOfService;
